import React, { useEffect, useRef, useState } from 'react'
import Dropzone from 'react-dropzone'
import { Input, Label, Button, Card, CardBody, CardTitle, Col, Row, Alert } from 'reactstrap';
import { formatBytes } from '../../common';
import "../../assets/css/--component-agent.css"
import dummyRoundedImage from "../../assets/images/dummy-voice-logo.png"
import dropzoneIcon from "../../assets/images/dropzone-icon.png"
import { createNewAgent, getPrompt, getVoices, getWebhookConfiguration, updatePrompt } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { useNavigate } from 'react-router-dom'
import { accentData } from '../../data/accentData';
import { useAppContext } from '../../context/AppContext';
import { getDefaultDataCollection } from '../../utils/defaultDataCollection';

export const DEFAULT_WIDGET_COLORS = {
    backgroundColor: "#ffffff",
    textColor: "#ffffff",
    chatTextColor: "#333333",
    headerColor: "#55d472",
    buttonColor: "#55d472"
};

const ColorPickerField = ({ id, label, value, fallbackValue, error, onChange }) => {
    const selectedColor = value || fallbackValue;

    return (
        <Col md={6} className='mb-4'>
            <Label htmlFor={id} className="text-left text-black font-bold">{label}</Label>

            <label htmlFor={id} className="widget-color-picker">
                <span
                    className="widget-color-picker__swatch"
                    style={{ backgroundColor: selectedColor }}
                />
                <span className="widget-color-picker__value">
                    {selectedColor.toUpperCase()}
                </span>
                <span className="widget-color-picker__action">Change</span>

                <input
                    type="color"
                    id={id}
                    value={selectedColor}
                    onChange={onChange}
                    className="widget-color-picker__input"
                />
            </label>

            {error && <p className="invalid-feedback">{error}</p>}
        </Col>
    );
};

const getPromptDataCollectionFields = (prompt = {}) => {
    const fields = [
        ...getDefaultDataCollection(),
        ...(Array.isArray(prompt.customDataCollection) ? prompt.customDataCollection : [])
    ];

    const usedKeys = new Set();

    return fields.filter((field) => {
        const key = field?.key?.trim();
        if (!key || usedKeys.has(key.toLowerCase())) return false;

        usedKeys.add(key.toLowerCase());
        return true;
    });
};

const CreateNewAgent = () => {
    const history = useNavigate();
    const { markTaskDoneTour, activeTour } = useAppContext();
    const [currentTab, setCurrentTab] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingVoices, setLoadingVoices] = useState(false);
    const [newAgent, setNewAgent] = useState({ language: "", accent: "", gender: "", age: "", agentPurpose: "", agentName: "", agentType: "outbound", initiateCallWebhookId: "", postCallWebhookId: "", files: [], previews: [], placement: "bottom-right", inheritFromWeb: false, backgroundColor: DEFAULT_WIDGET_COLORS.backgroundColor, textColor: DEFAULT_WIDGET_COLORS.textColor, chatTextColor: DEFAULT_WIDGET_COLORS.chatTextColor, headerColor: DEFAULT_WIDGET_COLORS.headerColor, buttonColor: DEFAULT_WIDGET_COLORS.buttonColor, borderRadius: "" })
    const [accents, setAccents] = useState([]);
    const [prompts, setPrompts] = useState([]);
    const [selectedPrompt, setSelectedPrompt] = useState({ _id: 0, title: "", prompt: "", firstMessage: "", customDataCollection: [] });
    const [editMode, setEditMode] = useState(false);
    const [files, setFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [audio, setAudio] = useState(null);
    const [selectedVoice, setSelectedVoice] = useState(1);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentlyPlayingVoice, setCurrentlyPlayingVoice] = useState(null);
    const [page, setPage] = useState(0);
    const audioRef = useRef(null);
    const steps = [
        { id: 1, label: "Choose Language & Voice", icon: <i className="ri-global-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-global-line"></i> },
        { id: 2, label: "Agent Prompt", icon: <i className="ri-terminal-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-terminal-line"></i> },
        { id: 3, label: "Agent Purpose & Data Capture", icon: <i className="ri-database-2-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-database-2-line"></i> },
    ];
    const [voices, setVoices] = useState([]);
    const [preConfigurations, setPreConfigurations] = useState([]);
    const [postConfigurations, setPostConfigurations] = useState([]);

    const getVoicesHandler = (page = 0, page_size = 30) => {
        setLoading(true);
        setLoadingVoices(true);
        setVoices([]);
        getVoices({ ...(newAgent.accent && { accent: newAgent.accent }), ...(newAgent.age && { age: newAgent.age }), ...(newAgent.gender && { gender: newAgent.gender }), ...(newAgent.language && { language: newAgent.language }), page: page, page_size: page_size }).then((data) => {
            // console.log("voices",data.data.voices)
            // const filteredVoices = (data.data?.voices || []).filter(voice => {
            //     if (voice.category !== 'cloned' || voice.category !== 'generated') {
            //         return true;
            //     }
            //     return voice.labels?.accent && voice.labels.accent === newAgent.accent;
            // });
            // const filteredVoices = (data.data?.voices || []).filter(voice => 
            //     voice.category !== 'cloned' && voice.category !== 'generated' 
            //     ? true 
            //     : voice.labels?.accent === newAgent.accent
            // );
            // const filteredVoices = (data.data?.voices || []).filter(voice => {
            //     if (voice.category !== 'cloned' && voice.category !== 'generated') {
            //         return true; // Include all non-cloned, non-generated voices
            //     }
            //     return voice.labels?.accent && voice.labels.accent === newAgent.accent;
            // });
            // const filteredVoices = (data.data?.voices || []).filter(voice =>
            //     voice.category !== 'cloned' && voice.category !== 'generated'
            //         ? true
            //         : !newAgent.accent || voice.labels?.accent === newAgent.accent
            // );

            const filteredVoices = (data.data?.voices || []).filter(voice => {
                const isClonedOrGenerated = voice.category === 'cloned' || voice.category === 'generated';
                if (!isClonedOrGenerated) {
                    return true;
                }
                const accentMatches = !newAgent.accent || voice.labels?.accent === newAgent.accent;
                const languageMatches = !newAgent.language || voice.labels?.language === newAgent.language;

                return accentMatches && languageMatches;
            });
            setVoices(filteredVoices);
            // setVoices(data.data && data.data.voices ? data.data.voices : [])
            setSelectedVoice(data.data.voices[0])
            // const uniqueAccent = [...new Set(data.data.voices.map(voice => voice.accent ? voice.accent : voice.labels.accent))];
            // const uniqueAccent = [
            //     ...new Set(
            //         data.data.voices
            //             .filter(voice => voice.accent || voice.labels?.accent)
            //             .map(voice => voice.accent || voice.labels.accent)
            //     )
            // ];
            // setAccents(prev => [...new Set([...prev, ...uniqueAccent].filter(item => item.trim() !== ''))]);
            setLoading(false);
            setLoadingVoices(false);
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
            setLoading(false);
            setLoadingVoices(false);
        })
    }
    const getPromptsHandler = (setSelected = true, promptSelectedData = null) => {
        setSelectedPrompt([]);
        getPrompt().then((data) => {
            if (data.data.length) {
                setPrompts(data.data)
                if (setSelected) {
                    setSelectedPrompt(data.data[0])
                } else {
                    setSelectedPrompt(promptSelectedData)
                }
            }
            else {
                showToast("error", "Request Failed", "Please create a prompt first.")
                setTimeout(() => {
                    history("/create-new-prompt")
                }, 3000);
            }
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const promptLockIcon = editMode ? "ri-lock-unlock-line" : "ri-lock-line";

    const handlePromptEdit = () => {
        let flag = false;
        let error = { title: false, purpose: false, firstMessage: false, prompt: false };

        if (!selectedPrompt.title || selectedPrompt.title.replace(/\s/g, '').length < 1) {
            flag = true;
            error.title = "Please provide valid title";
        }

        if (!selectedPrompt.purpose || selectedPrompt.purpose.replace(/\s/g, '').length < 1) {
            flag = true;
            error.purpose = "Please provide valid purpose";
        }

        if (!selectedPrompt.firstMessage || selectedPrompt.firstMessage.replace(/\s/g, '').length < 1) {
            flag = true;
            error.firstMessage = "Please provide first message";
        }

        if (!selectedPrompt.prompt || selectedPrompt.prompt.replace(/\s/g, '').length < 1) {
            flag = true;
            error.prompt = "Please provide a valid prompt";
        }

        setErrors(error);

        if (!flag) {
            setLoading(true);

            const formData = {
                title: selectedPrompt.title,
                purpose: selectedPrompt.purpose,
                firstMessage: selectedPrompt.firstMessage,
                prompt: selectedPrompt.prompt
            };

            updatePrompt(formData, selectedPrompt._id).then((data) => {
                if (data) {
                    showToast("success", "Prompt Updated", "Your selected prompt has been updated successfully.");
                    setLoading(false);
                    setEditMode(false);
                    getPromptsHandler(false, data.data);
                }
            }).catch((e) => {
                showToast("error", "Prompt Request Failed", "Your prompt could not be updated.");
                setLoading(false);
            });
        }
    };

    const exploreMoreHandler = (currentPage) => {
        setPage(prev => prev + 1)
        getVoicesHandler(currentPage + 1, 30)
    }

    useEffect(() => {
        getVoicesHandler()
    }, [newAgent.accent, newAgent.age, newAgent.gender, newAgent.language])
    useEffect(() => {
        getPromptsHandler()
    }, [])
    useEffect(() => {
        fetchConfigurations()
    }, [])
    useEffect(() => {
        if (!newAgent.language) {
            const accents = [];
            Object.values(accentData).forEach(langAccents => {
                langAccents.forEach(accent => {
                    if (!accents.includes(accent)) {
                        accents.push(accent);
                    }
                });
            });
            setAccents(accents.sort());
        }
        else {
            setAccents(accentData[newAgent.language]?.sort())
        }
    }, [newAgent.language])

    const fetchConfigurations = async () => {
        setLoading(true);
        try {
            const data = await getWebhookConfiguration();
            if (data?.status && data.data) {
                const configs = Array.isArray(data.data) ? data.data : [data.data];

                // Filter PRE and POST configurations
                const preConfigs = configs
                    .filter(config => config.webhookType === "PRE")
                    .map(config => ({
                        ...config,
                    }));

                const postConfigs = configs
                    .filter(config => config.webhookType === "POST")
                    .map(config => ({
                        ...config,
                    }));

                setPreConfigurations(preConfigs.length ? preConfigs : []);
                setPostConfigurations(postConfigs.length ? postConfigs : []);

            } else {
                setPreConfigurations([]);
                setPostConfigurations([]);
            }
        } catch (err) {
            console.error("Fetch failed:", err);
            showToast("error", "Request Failed", err.message);
            setPreConfigurations([]);
            setPostConfigurations([]);
        } finally {
            setLoading(false);
        }
    };


    const nextStep = (step, validate = true) => {
        if (!validate) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setCurrentTab(step);
        }
        if (step === 2) {
            let flag = false;
            let error = { voices: false };
            if (!selectedVoice) {
                flag = true;
                error.voices = "Please select a voice";
            }
            setErrors(error)
            if (!flag) {
                setCurrentTab(2);
            }
        }
        if (step === 3) {
            setCurrentTab(3);
        }
        if (step === 4) {
            let flag = false;
            let error = { agentPurpose: false, agentName: false, initiateCallWebhookId: false, postCallWebhookId: false };
            if (!newAgent.agentName || newAgent.agentName.replace(/\s/g, '').length < 1) {
                flag = true;
                error.agentName = "Please provide a valid name";
            }
            if (newAgent.agentType === "webhook") {
                if (!newAgent.initiateCallWebhookId || newAgent.initiateCallWebhookId.replace(/\s/g, '').length < 1) {
                    flag = true;
                    error.initiateCallWebhookId = "Please provide a valid Initiate Call Webhook";
                }
                // if (!newAgent.postCallWebhookId || newAgent.postCallWebhookId.replace(/\s/g, '').length < 1) {
                //     flag = true;
                //     error.postCallWebhookId = "Please provide a valid Post Call Webhook";
                // }
            }
            if (newAgent.agentType === "website") {
                if (!newAgent.inheritFromWeb) {
                    if (!newAgent.backgroundColor || newAgent.backgroundColor.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.backgroundColor = "Please provide a valid background color for widget";
                    }
                    if (!newAgent.textColor || newAgent.textColor.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.textColor = "Please provide a valid text color for widget";
                    }
                    if (!newAgent.chatTextColor || newAgent.chatTextColor.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.chatTextColor = "Please provide a valid chat box color for widget";
                    }
                    if (!newAgent.headerColor || newAgent.headerColor.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.headerColor = "Please provide a valid header color for widget";
                    }
                    if (!newAgent.buttonColor || newAgent.buttonColor.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.buttonColor = "Please provide a valid button color for widget";
                    }
                    if (!newAgent.borderRadius || newAgent.borderRadius.replace(/\s/g, '').length < 1) {
                        flag = true;
                        error.borderRadius = "Please provide a valid border radius for widget";
                    }
                }
            }
            setErrors(error)
            if (!flag) {
                setLoading(true);
                // let modelId = selectedVoice.verified_languages.find(x => x.model_id === "eleven_flash_v2_5")?.model_id
                //     ?? selectedVoice.verified_languages.find(x => x.model_id === "eleven_multilingual_v2")?.model_id
                //     ?? selectedVoice.verified_languages[0]?.model_id;
                let modelId =
                    selectedVoice.verified_languages?.find(x => x.model_id === "eleven_flash_v2_5")?.model_id
                    ?? selectedVoice.verified_languages?.find(x => x.model_id === "eleven_multilingual_v2")?.model_id
                    ?? selectedVoice.verified_languages?.[0]?.model_id
                    ?? "eleven_flash_v2_5";
                const formData = new FormData();
                formData.append("name", newAgent.agentName);
                formData.append("prompt", selectedPrompt.prompt);
                formData.append("firstMessage", selectedPrompt.firstMessage);
                for (let file of files) {
                    formData.append(`knowledgeBaseFiles`, file);
                }
                // formData.append("firstMessage", event.entitytype);
                formData.append("language", selectedVoice.language ? selectedVoice.language : selectedVoice.labels?.language);
                formData.append("voiceId", selectedVoice.voice_id);
                formData.append("modelId", modelId);
                formData.append("public_owner_id", selectedVoice.public_owner_id);
                formData.append("voice_name", selectedVoice.name);
                formData.append("type", newAgent.agentType);
                if (newAgent.agentType === "webhook") {
                    formData.append("initiateCallWebhookId", newAgent.initiateCallWebhookId);
                    formData.append("postCallWebhookId", newAgent.postCallWebhookId);
                }
                if (newAgent.agentType === "website") {
                    formData.append("placement", newAgent.placement);
                    formData.append("inheritFromWeb", newAgent.inheritFromWeb);
                    if (!newAgent.inheritFromWeb) {
                        formData.append("backgroundColor", newAgent.backgroundColor);
                        formData.append("textColor", newAgent.textColor);
                        formData.append("chatTextColor", newAgent.chatTextColor);
                        formData.append("headerColor", newAgent.headerColor);
                        formData.append("buttonColor", newAgent.buttonColor);
                        formData.append("borderRadius", newAgent.borderRadius);
                    }
                }
                formData.append("purpose", selectedPrompt.purpose);
                formData.append("customDataCollection", JSON.stringify(selectedPromptDataCollection));
                createNewAgent(formData).then((data) => {
                    showToast("success", "Agent Created", "Your new agent has been created successfully.")
                    setLoading(false);
                    const isInPromptTour = activeTour && activeTour.taskId === 2;

                    if (isInPromptTour) {
                        // Close any open driver.js instance first
                        const driverInstance = document.querySelector('.driver-popover');
                        if (driverInstance) {
                            // Find and trigger the close button
                            const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                            if (closeBtn) {
                                closeBtn.click();
                            }
                        }

                        // Small delay to ensure driver.js is closed
                        setTimeout(() => {
                            markTaskDoneTour(2);
                        }, 100);
                    } else {
                        markTaskDoneTour(2, false);
                        history('/agents');
                    }
                    // history('/agents')
                }).catch((e) => {
                    showToast("error", "Agent Request Failed", "Your new agent could not be created.")
                    setLoading(false);
                })
            }
        }
    }

    const handlePlayPause = async (voice, voiceSrc) => {
        // If the same voice is clicked again, pause it
        if (currentlyPlayingVoice === voice.voice_id && isPlaying) {
            if (audioRef.current) {
                audioRef.current.pause();
                setIsPlaying(false);
            }
            return;
        }

        // Stop the currently playing audio (if any)
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = ''; // Clear the src to stop fetching
        }

        // If voiceSrc is invalid, exit early
        if (!voiceSrc) return;

        try {
            // Create new audio object
            const audio = new Audio(voiceSrc);

            // Add ended event listener to reset state when audio finishes
            audio.onended = () => {
                setIsPlaying(false);
                setCurrentlyPlayingVoice(null);
            };
            // Wait for the metadata to load to ensure validity
            audio.onloadedmetadata = async () => {
                if (audio.duration > 0) {
                    audioRef.current = audio;
                    await audioRef.current.play();
                    setIsPlaying(true); // Set playing state to true
                    setCurrentlyPlayingVoice(voice.voice_id); // Set the currently playing voice
                } else {
                    console.error('Invalid audio file:', voiceSrc);
                    setIsPlaying(false);
                    setCurrentlyPlayingVoice(null);
                }
            };

            // Handle loading errors
            audio.onerror = () => {
                console.error('Error loading audio:', voiceSrc);
                setIsPlaying(false);
                setCurrentlyPlayingVoice(null);
            };
        } catch (error) {
            console.error('Error playing audio:', error);
            setIsPlaying(false);
            setCurrentlyPlayingVoice(null);
        }
    };

    const handleVoiceSelect = (voice) => {
        // Set the selected voice
        setSelectedVoice(voice);
        setIsPlaying(false); // Ensure playing state is reset
        setCurrentlyPlayingVoice(null); // Reset the currently playing voice
    };


    const handleAcceptedFiles = (acceptedFiles) => {
        setErrors((prev) => ({ ...prev, file: '' }));

        const allowedFormats = ['pdf', 'txt', 'docx', 'epub', 'html'];
        const maxFileSize = 22020096; // 21 MB in bytes

        const validFormatFiles = acceptedFiles.filter((file) => {
            const fileExt = file.name.split('.').pop().toLowerCase();
            return allowedFormats.includes(fileExt);
        });

        const validSizeFiles = validFormatFiles.filter((file) => {
            return file.size <= maxFileSize && file.size > 0;
        });

        if (validFormatFiles.length !== acceptedFiles.length) {
            setErrors((prev) => ({ ...prev, file: 'Only upload files with allowed formats (pdf, txt, docx)' }));
            return
        }
        else if (validSizeFiles.length !== validFormatFiles.length) {
            const hasEmptyFiles = validFormatFiles.some((file) => file.size === 0);
            if (hasEmptyFiles) {
                setErrors((prev) => ({ ...prev, file: 'File cannot be empty' }));
                return
            } else {
                setErrors((prev) => ({ ...prev, file: 'File size should not be greater than 21 MB' }));
                return
            }
        }

        const formattedFiles = validSizeFiles.map(file => Object.assign(file, { formattedSize: formatBytes(file.size) }));

        setFiles((prev) => [...prev, ...formattedFiles]);
    };

    // Handler to clear a specific file
    const clearFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    const handlePromptchange = (id) => {
        const selectedID = id;
        const selectedItem = prompts.find((item) => item._id === selectedID);
        setSelectedPrompt(selectedItem ? selectedItem : {});
        setEditMode(false);
    };

    const selectedPromptDataCollection = getPromptDataCollectionFields(selectedPrompt);

    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 row">
                        <div className="col-12">
                            <Row className="my-2 align-items-center">
                                <Col md={12}>
                                    <h4>Create New Agent</h4>
                                    <p className='text-muted fs-12'>Create a new agent</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row className='card-row'>
                        <Col md={12}>
                            <Card className='bg-white rounded-2' id='agent-form'>
                                <CardBody>
                                    <div className="d-flex justify-content-center align-items-start mb-5">
                                        {steps.map((step, index) => (
                                            <React.Fragment key={step.id}>
                                                <div className="d-flex flex-column align-items-center justify-content-center text-center step-card">
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center text-white fs-16`}
                                                        style={{ width: "40px", height: "40px", borderRadius: "10px", border: index === currentTab - 1 ? "none" : "1px solid #e6e6e6", background: index === currentTab - 1 ? "var(--wr-gradient-brand)" : "#fff" }}
                                                    >
                                                        {index === currentTab - 1 ? step.iconActive : step.icon}
                                                    </div>
                                                    <div className="">
                                                        <h6 className={`mb-0 mt-2 ${index === currentTab - 1 ? "text-black" : "text-muted"}`}>{step.label}</h6>
                                                        {/* <small className={`${index === currentTab - 1 ? "text-black" : "text-muted"}`}>{step.description}</small> */}
                                                    </div>
                                                </div>
                                                {index < 2 ? <span style={{ width: "90px", height: "2px", display: "inline-block", background: "#e6e6e6", marginTop: "20px" }}></span> : null}
                                            </React.Fragment>
                                        ))}
                                    </div>

                                    {
                                        currentTab === 1 ?
                                            <>
                                                <h4 className='mb-4'>Choose Agent Language and Accent</h4>
                                                <Row>
                                                    <Col md={6} className='mb-3'>
                                                        <Label htmlFor="language" className="text-left text-black font-bold"> Choose Language </Label>
                                                        <Input id="language" className='custom-select rounded border-0 py-2' type="select" value={newAgent.language} onChange={(e) => { setAccents([]); setNewAgent((prev) => { return { ...prev, language: e.target.value, accent: "" } }); }} >
                                                            <option value="">Select a language</option>
                                                            {/* <option value="ar">Arabic</option>
                                                            <option value="cs">Czech</option>
                                                            <option value="en">English</option>
                                                            <option value="fr">French</option>
                                                            <option value="de">German</option>
                                                            <option value="el">Greek</option>
                                                            <option value="hi">Hindi</option>
                                                            <option value="id">Indonesian</option>
                                                            <option value="pl">Polish</option>
                                                            <option value="ro">Romanian</option>
                                                            <option value="sk">Slovak</option>
                                                            <option value="es">Spanish</option>
                                                            <option value="tr">Turkish</option> */}
                                                            <option value="ar">Arabic</option>
                                                            <option value="bg">Bulgarian</option>
                                                            <option value="zh">Chinese</option>
                                                            <option value="hr">Croatian</option>
                                                            <option value="cs">Czech</option>
                                                            <option value="da">Danish</option>
                                                            <option value="nl">Dutch</option>
                                                            <option value="en">English</option>
                                                            <option value="fil">Filipino</option>
                                                            <option value="fi">Finnish</option>
                                                            <option value="fr">French</option>
                                                            <option value="de">German</option>
                                                            <option value="el">Greek</option>
                                                            <option value="hi">Hindi</option>
                                                            <option value="hu">Hungarian</option>
                                                            <option value="id">Indonesian</option>
                                                            <option value="it">Italian</option>
                                                            <option value="ja">Japanese</option>
                                                            <option value="ko">Korean</option>
                                                            <option value="ms">Malay</option>
                                                            <option value="no">Norwegian</option>
                                                            <option value="pl">Polish</option>
                                                            <option value="pt">Portuguese</option>
                                                            <option value="ro">Romanian</option>
                                                            <option value="ru">Russian</option>
                                                            <option value="sk">Slovak</option>
                                                            <option value="es">Spanish</option>
                                                            <option value="sw">Swahili</option>
                                                            <option value="sv">Swedish</option>
                                                            <option value="ta">Tamil</option>
                                                            <option value="tr">Turkish</option>
                                                            <option value="uk">Ukrainian</option>
                                                            <option value="vi">Vietnamese</option>
                                                        </Input>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <Label htmlFor="accent" className="text-left text-black font-bold"> Choose Accent </Label>
                                                        <Input id="accent" className='custom-select rounded border-0 py-2' type="select" value={newAgent.accent} onChange={(e) => { setNewAgent((prev) => { return { ...prev, accent: e.target.value } }); }} >
                                                            <option value="">Choose Accent</option>
                                                            {accents?.map((item) => (
                                                                <option key={item} value={item} className='text-capitalize'>
                                                                    {item}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <Label htmlFor="gender" className="text-left text-black font-bold"> Choose Gender </Label>
                                                        <Input id="gender" className='custom-select rounded border-0 py-2' type="select" value={newAgent.gender} onChange={(e) => { setNewAgent((prev) => { return { ...prev, gender: e.target.value } }); }} >
                                                            <option value="">Select a gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </Input>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <Label htmlFor="age" className="text-left text-black font-bold"> Choose Age </Label>
                                                        <Input id="age" className='custom-select rounded border-0 py-2' type="select" value={newAgent.age} onChange={(e) => { setNewAgent((prev) => { return { ...prev, age: e.target.value } }); }} >
                                                            <option value="">Select an age</option>
                                                            <option value="young">Young</option>
                                                            <option value="middle_aged">Middle Aged</option>
                                                            <option value="old">Old</option>
                                                        </Input>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <Row>
                                                            <Col md={6}>
                                                                <h4 className='mb-4 mt-4'>Choose Voice</h4>
                                                            </Col>
                                                            <Col md={6} className='text-right'>
                                                                <div className='d-flex align-items-center justify-content-end gap-2'>

                                                                    {
                                                                        voices.length ?
                                                                            <>
                                                                                <Button disabled={loading} onClick={() => { nextStep(2) }} className="px-4 py-2 rounded linear-gradient-btn">Next</Button>
                                                                                <button
                                                                                    disabled={loading}
                                                                                    onClick={() => { exploreMoreHandler(page) }}
                                                                                    className="px-2 py-2 rounded mb-4 mt-4 outline-gradient-btn"
                                                                                >
                                                                                    <span>Explore More</span>
                                                                                </button>
                                                                            </> : null
                                                                    }
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="voice-selection">
                                                            <div className="voice-list">
                                                                {
                                                                    loadingVoices ?
                                                                        <Alert color="info">Please wait while we fetch agent's voices...</Alert>
                                                                        :
                                                                        voices.length ?
                                                                            voices.map((voice, i) => (
                                                                                <Card
                                                                                    key={voice.voice_id}
                                                                                    className={`w-100 voice-card ${selectedVoice.voice_id === voice.voice_id ? 'selected' : ''}`}
                                                                                    onClick={() => handleVoiceSelect(voice)} // Only select the voice
                                                                                    style={{ borderRadius: "50px", background: "#fafafa" }}
                                                                                >
                                                                                    <div className='d-flex justify-content-between align-items-center p-3'>
                                                                                        <div className="voice-left">
                                                                                            <div className="voice-header">
                                                                                                <div className="voice-logo">
                                                                                                    <img src={dummyRoundedImage} alt={voice.name} />
                                                                                                    {selectedVoice.voice_id === voice.voice_id && (
                                                                                                        <i className="ri-check-line checked-icon"></i>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className='ms-2'>
                                                                                                    {/* <h5 className='text-capitalize'>voice {i + 1} ({voice.accent ? voice.accent : voice.labels?.accent} - {voice.gender ? voice.gender : voice.labels?.gender} - {voice.age ? voice.age.replace(/_/g, " ") : voice.labels?.age.replace(/_/g, " ")})</h5> */}
                                                                                                    <h5 className='text-capitalize'>
                                                                                                        voice {i + 1} {
                                                                                                            voice.category !== "cloned" ? (
                                                                                                                <> ({voice.accent ? voice.accent : voice.labels?.accent}
                                                                                                                    - {voice.gender ? voice.gender : voice.labels?.gender}
                                                                                                                    - {voice.age ? voice.age.replace(/_/g, " ") : voice.labels?.age?.replace(/_/g, " ")})</>
                                                                                                            ) : (
                                                                                                                <> ({voice.name})</>
                                                                                                            )
                                                                                                        }
                                                                                                    </h5>
                                                                                                    <p className='voice-desc m-0'>{(voice?.description ?? "").replace(/elevenlabs/gi, "wiserep")}</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="voice-right">
                                                                                            <button
                                                                                                className="play-button"
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation(); // Prevent card click event
                                                                                                    handlePlayPause(voice, voice.preview_url); // Pass the voice and preview URL
                                                                                                }}
                                                                                            >
                                                                                                <i
                                                                                                    className={
                                                                                                        currentlyPlayingVoice === voice.voice_id && isPlaying
                                                                                                            ? 'ri-pause-line'
                                                                                                            : 'ri-play-fill'
                                                                                                    }
                                                                                                    style={{ color: "var(--wr-primary)" }}
                                                                                                ></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </Card>
                                                                            )) : <Alert color="danger">Sorry, No Voices Found</Alert>
                                                                }
                                                            </div>
                                                        </div>
                                                        {errors.voices && <p className="invalid-feedback">{errors.voices}</p>}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12} className='text-right'>
                                                        <Button id='show-agent-prompt-btn' disabled={loading} onClick={() => { nextStep(2) }} className="px-4 py-2 rounded linear-gradient-btn">Next</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                            :
                                            currentTab === 2 ?
                                                <>
                                                    <h4 className='mb-4'>Company Information and Prompt</h4>
                                                    <Row>
                                                        <Col md={12} className='mb-4'>
                                                            <Label htmlFor="prompt" className="text-left text-black font-bold"> Choose Prompt </Label>
                                                            <Input id="prompt" className='custom-select rounded border-0 py-2' type="select" onChange={(e) => { handlePromptchange(e.target.value) }} >
                                                                {prompts.map((item) => (
                                                                    <option key={item._id} value={item._id}>
                                                                        {item.title}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                        </Col>
                                                        <Col md={12} className='mb-4'>
                                                            <Row className="align-items-center">
                                                                <Col md={6}>
                                                                    <Label htmlFor="purpose" className="text-left text-black font-bold">
                                                                        <i className={`${promptLockIcon} me-1`}></i>
                                                                        Agent Purpose
                                                                    </Label>
                                                                </Col>
                                                                <Col md={6} className="text-right">
                                                                    {!editMode ? (
                                                                        <p className='text-primary cursor-pointer mb-0' onClick={() => setEditMode(true)}>
                                                                            <i className="ri-edit-box-line"></i> Edit
                                                                        </p>
                                                                    ) : (
                                                                        <span className="text-success fs-13">
                                                                            <i className="ri-lock-unlock-line me-1"></i>
                                                                            Editable
                                                                        </span>
                                                                    )}
                                                                </Col>
                                                            </Row>

                                                            <input
                                                                type="text"
                                                                disabled={!editMode}
                                                                id="purpose"
                                                                className="form-control custom-input"
                                                                value={selectedPrompt.purpose || ""}
                                                                onChange={(e) => setSelectedPrompt(prev => ({ ...prev, purpose: e.target.value }))}
                                                            />
                                                            {errors.purpose && <p className="invalid-feedback">{errors.purpose}</p>}
                                                        </Col>

                                                        <Col md={12} className='mb-4'>
                                                            <Label htmlFor="firstMessage" className="text-left text-black font-bold">
                                                                <i className={`${promptLockIcon} me-1`}></i>
                                                                First Message
                                                            </Label>

                                                            <Input
                                                                id="firstMessage"
                                                                disabled={!editMode}
                                                                className='custom-input rounded border-0 py-2'
                                                                type="text"
                                                                value={selectedPrompt.firstMessage || ""}
                                                                onChange={(e) => setSelectedPrompt(prev => ({ ...prev, firstMessage: e.target.value }))}
                                                            />
                                                            {errors.firstMessage && <p className="invalid-feedback text-left">{errors.firstMessage}</p>}
                                                        </Col>

                                                        <Col md={12} className='mb-4'>
                                                            <Label htmlFor="prompt-content" className="text-left text-black font-bold">
                                                                <i className={`${promptLockIcon} me-1`}></i>
                                                                Prompt
                                                            </Label>

                                                            <textarea
                                                                id="prompt-content"
                                                                disabled={!editMode}
                                                                value={selectedPrompt.prompt || ""}
                                                                onChange={(e) => setSelectedPrompt(prev => ({ ...prev, prompt: e.target.value }))}
                                                                className='fs-16 rounded p-2 custom-textarea'
                                                            />

                                                            {errors.prompt && <p className="invalid-feedback">{errors.prompt}</p>}

                                                            {editMode ? (
                                                                <Button className="me-3 mt-2 linear-gradient-btn" disabled={loading} onClick={handlePromptEdit}>
                                                                    Save
                                                                </Button>
                                                            ) : null}
                                                        </Col>

                                                        <Col md={12} className='mb-4'>
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <Label className="text-left text-black font-bold mb-0">
                                                                    Data Collection
                                                                </Label>
                                                                <span className="text-muted fs-12">
                                                                    <i className="ri-lock-line me-1"></i>
                                                                    Read only
                                                                </span>
                                                            </div>

                                                            {selectedPromptDataCollection.length ? (
                                                                selectedPromptDataCollection.map((field, index) => (
                                                                    <Row className="align-items-end mb-3" key={`${field.key}-${index}`}>
                                                                        <Col md={3} className="mb-2">
                                                                            <Label className="text-left text-black font-bold">Key</Label>
                                                                            <Input
                                                                                disabled
                                                                                className='custom-input form-control rounded border-0 py-2'
                                                                                value={field.key || ""}
                                                                            />
                                                                        </Col>

                                                                        <Col md={3} className="mb-2">
                                                                            <Label className="text-left text-black font-bold">Type</Label>
                                                                            <Input
                                                                                disabled
                                                                                className='custom-input form-control rounded border-0 py-2'
                                                                                value={field.type || ""}
                                                                            />
                                                                        </Col>

                                                                        <Col md={6} className="mb-2">
                                                                            <Label className="text-left text-black font-bold">Description</Label>
                                                                            <Input
                                                                                disabled
                                                                                className='custom-input form-control rounded border-0 py-2'
                                                                                value={field.description || ""}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                ))
                                                            ) : (
                                                                <Alert color="info" className="mb-0">
                                                                    No data collection fields configured for this prompt.
                                                                </Alert>
                                                            )}
                                                        </Col>

                                                    </Row>
                                                    <Row>
                                                        <Col md={12} className='text-right'>
                                                            <Button onClick={() => { setCurrentTab(1) }} className="px-4 py-2 rounded me-2 linear-gradient-btn">Back</Button>
                                                            <Button disabled={loading} onClick={() => { nextStep(3) }} className="px-4 py-2 rounded linear-gradient-btn">Next</Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                                :
                                                <>
                                                    <h4 className='mb-4'>Agent Purpose & Data Capture</h4>
                                                    <Row>
                                                        {/* <Col md={12} className='mb-4'>
                                                            <Label htmlFor="purpose" className="text-left text-black font-bold"> Agent Purpose </Label>
                                                            <input type="text" id="purpose" className={`form-control custom-input`} value={newAgent.agentPurpose} onChange={(e) => setNewAgent((prev) => { return { ...prev, agentPurpose: e.target.value } })} />
                                                            {errors.agentPurpose && <p className="invalid-feedback">{errors.agentPurpose}</p>}
                                                        </Col> */}
                                                        <Col md={6} className='mb-4'>
                                                            <Label htmlFor="agentName" className="text-left text-black font-bold"> Agent Name </Label>
                                                            <input type="text" id="agentName" className={`form-control custom-input`} value={newAgent.agentName} onChange={(e) => setNewAgent((prev) => { return { ...prev, agentName: e.target.value } })} />
                                                            {errors.agentName && <p className="invalid-feedback">{errors.agentName}</p>}
                                                        </Col>
                                                        <Col md={6} className='mb-4'>
                                                            <Label htmlFor="agentType" className="text-left text-black font-bold"> Agent Type </Label>
                                                            <Input id="agentType" className='custom-select rounded border-0 py-2' type="select" value={newAgent.agentType} onChange={(e) => { setNewAgent((prev) => { return { ...prev, agentType: e.target.value } }); }} >
                                                                <option value="outbound">Outbound</option>
                                                                <option value="inbound">Inbound</option>
                                                                <option value="website">Website</option>
                                                                {
                                                                    preConfigurations.length ?
                                                                        <option value="webhook">Webhook</option> : null
                                                                }
                                                            </Input>
                                                        </Col>
                                                    </Row>
                                                    {
                                                        newAgent.agentType === "webhook" ?
                                                            <Row>
                                                                <Col md={6} className='mb-4'>
                                                                    <Label htmlFor="agentType" className="text-left text-black font-bold"> Initial Call Webhook </Label>
                                                                    <Input id="agentType" className='custom-select rounded border-0 py-2' type="select" value={newAgent.initiateCallWebhookId} onChange={(e) => { setNewAgent((prev) => { return { ...prev, initiateCallWebhookId: e.target.value } }); }} >
                                                                        <option value="">Select Option</option>
                                                                        {
                                                                            preConfigurations.map((config, i) => {
                                                                                return <option key={config._id} value={config._id}>{config.title}</option>
                                                                            })
                                                                        }
                                                                    </Input>
                                                                    {errors.initiateCallWebhookId && <p className="invalid-feedback">{errors.initiateCallWebhookId}</p>}
                                                                </Col>
                                                                <Col md={6} className='mb-4'>
                                                                    <Label htmlFor="agentType" className="text-left text-black font-bold"> Post Call Webhook </Label>
                                                                    <Input id="agentType" className='custom-select rounded border-0 py-2' type="select" value={newAgent.postCallWebhookId} onChange={(e) => { setNewAgent((prev) => { return { ...prev, postCallWebhookId: e.target.value } }); }} >
                                                                        <option value="">Select Option</option>
                                                                        {
                                                                            postConfigurations.map((config, i) => {
                                                                                return <option key={config._id} value={config._id}>{config.title}</option>
                                                                            })
                                                                        }
                                                                    </Input>
                                                                    {errors.postCallWebhookId && <p className="invalid-feedback">{errors.postCallWebhookId}</p>}
                                                                </Col>
                                                            </Row> : null
                                                    }
                                                    {
                                                        newAgent.agentType === "website" ?
                                                            <Row>
                                                                {/* <Col md={6} className='mb-4'>
                                                                    <Row>
                                                                        <Col md={6}>
                                                                            <div className='mt-3'>
                                                                                <Label className="text-left text-black font-bold">
                                                                                    Inherit Styles From Website
                                                                                </Label>
                                                                                <div className="form-check form-switch gradient-switch agent-update-switch">
                                                                                    <input
                                                                                        role='switch'
                                                                                        type="checkbox"
                                                                                        checked={newAgent.inheritFromWeb}
                                                                                        onChange={(e) => setNewAgent((prev) => { return { ...prev, inheritFromWeb: !newAgent.inheritFromWeb } })}
                                                                                        className="form-check-input"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col> */}
                                                                <Col md={6} className='mb-4'>
                                                                    <Label htmlFor="placement" className="text-left text-black font-bold"> Placement </Label>
                                                                    <Input id="placement" className='custom-select rounded border-0 py-2' type="select" value={newAgent.placement} onChange={(e) => { setNewAgent((prev) => { return { ...prev, placement: e.target.value } }); }} >
                                                                        {/* <option value="bottom">Bottom</option> */}
                                                                        <option value="bottom-right">Bottom-Right</option>
                                                                        <option value="bottom-left">Bottom-Left</option>
                                                                        {/* <option value="top">Top</option> */}
                                                                        <option value="top-right">Top-Right</option>
                                                                        <option value="top-left">Top-Left</option>
                                                                    </Input>
                                                                </Col>
                                                                {/* <Col md={6} className='mb-4'>
                                                                    <Label htmlFor="avatarUrl" className="text-left text-black font-bold"> Avatar URL </Label>
                                                                    <input type="text" id="avatarUrl" placeholder='Avatar URL for Chat Box' className={`form-control custom-input`} value={newAgent.avatarCustomUrl} onChange={(e) => setNewAgent((prev) => { return { ...prev, avatarCustomUrl: e.target.value } })} />
                                                                    {errors.avatarCustomUrl && <p className="invalid-feedback">{errors.avatarCustomUrl}</p>}
                                                                </Col> */}
                                                                {/* <Col md={6} className='mb-4'>
                                                                    <Label htmlFor="mainLabel" placeholder="e.g. Need Help?" className="text-left text-black font-bold"> Main Label </Label>
                                                                    <input type="text" id="mainLabel" className={`form-control custom-input`} value={newAgent.textContentsMainLabel} onChange={(e) => setNewAgent((prev) => { return { ...prev, textContentsMainLabel: e.target.value } })} />
                                                                </Col> */}
                                                                {
                                                                    !newAgent.inheritFromWeb ?
                                                                        <>
                                                                            <ColorPickerField
                                                                                id="bg-color"
                                                                                label="Chat Background Color"
                                                                                value={newAgent.backgroundColor}
                                                                                fallbackValue={DEFAULT_WIDGET_COLORS.backgroundColor}
                                                                                error={errors.backgroundColor}
                                                                                onChange={(e) => setNewAgent(prev => ({ ...prev, backgroundColor: e.target.value }))}
                                                                            />

                                                                            <ColorPickerField
                                                                                id="text-color"
                                                                                label="Header Text Color"
                                                                                value={newAgent.textColor}
                                                                                fallbackValue={DEFAULT_WIDGET_COLORS.textColor}
                                                                                error={errors.textColor}
                                                                                onChange={(e) => setNewAgent(prev => ({ ...prev, textColor: e.target.value }))}
                                                                            />

                                                                            <ColorPickerField
                                                                                id="chat-color"
                                                                                label="Chat Text Color"
                                                                                value={newAgent.chatTextColor}
                                                                                fallbackValue={DEFAULT_WIDGET_COLORS.chatTextColor}
                                                                                error={errors.chatTextColor}
                                                                                onChange={(e) => setNewAgent(prev => ({ ...prev, chatTextColor: e.target.value }))}
                                                                            />

                                                                            <ColorPickerField
                                                                                id="header-color"
                                                                                label="Header Background Color"
                                                                                value={newAgent.headerColor}
                                                                                fallbackValue={DEFAULT_WIDGET_COLORS.headerColor}
                                                                                error={errors.headerColor}
                                                                                onChange={(e) => setNewAgent(prev => ({ ...prev, headerColor: e.target.value }))}
                                                                            />

                                                                            <ColorPickerField
                                                                                id="button-color"
                                                                                label="Button Color"
                                                                                value={newAgent.buttonColor}
                                                                                fallbackValue={DEFAULT_WIDGET_COLORS.buttonColor}
                                                                                error={errors.buttonColor}
                                                                                onChange={(e) => setNewAgent(prev => ({ ...prev, buttonColor: e.target.value }))}
                                                                            />


                                                                            <Col md={6} className='mb-4'>
                                                                                <Label htmlFor="border-radius" className="text-left text-black font-bold"> Border Radius </Label>
                                                                                <input type="text" id="border-radius" placeholder="e.g. 8px" className={`form-control custom-input`} value={newAgent.borderRadius} onChange={(e) => setNewAgent((prev) => { return { ...prev, borderRadius: e.target.value } })} />
                                                                                {errors.borderRadius && <p className="invalid-feedback">{errors.borderRadius}</p>}
                                                                            </Col>
                                                                        </> : null
                                                                }
                                                            </Row>
                                                            : null
                                                    }
                                                    <Row>
                                                        <Col md={12} className="agents-knowledgebase">
                                                            <Label htmlFor="purpose" className="text-left text-black font-bold"> Document for Knowledgebase </Label>
                                                            <div className='custom-file-upload'>
                                                                <Dropzone
                                                                    accept={{
                                                                        'application/epub+zip': ['.epub'],
                                                                        'application/pdf': ['.pdf'],
                                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
                                                                        'text/plain': ['.txt'],
                                                                        'text/html': ['.html', '.htm']
                                                                    }}
                                                                    multiple={true}
                                                                    onDropAccepted={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
                                                                    onDropRejected={(rejections) => {
                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            file: "Only upload files with allowed formats (pdf, txt, docx, epub, html)"
                                                                        }));
                                                                    }}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div className="dropzone" {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <div className="dz-message">
                                                                                <img src={dropzoneIcon} alt="dropzone icon" className='my-2' />
                                                                                <h6>Drag & Drop to upload file</h6>
                                                                                <p>OR</p>
                                                                                <span>Browse File</span>
                                                                                <p>(Max: 21MB | Supports: pdf, txt, docx, html, epub)</p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>

                                                                {files.length > 0 && (
                                                                    <div className="uploaded-files">
                                                                        {files.map((file, index) => (
                                                                            <div key={index} className="uploaded-file-card">
                                                                                <div className="file-info">
                                                                                    <p><i className="ri-file-text-line me-2 fs-20"></i> <b>{file.path}</b></p>
                                                                                </div>
                                                                                <span
                                                                                    className="clear-btn"
                                                                                    onClick={() => clearFile(index)}
                                                                                >
                                                                                    <i className="ri-close-circle-line"></i>
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                                {/* {errors.file && <p className="error-message">{errors.file}</p>} */}
                                                            </div>

                                                            {errors.file && <p className="invalid-feedback">{errors.file}</p>}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={12} className='text-right'>
                                                            <Button onClick={() => { setCurrentTab(2) }} className="px-4 py-2 rounded me-2 linear-gradient-btn">Back</Button>
                                                            <Button disabled={loading} onClick={() => { nextStep(4) }} className="px-4 py-2 rounded linear-gradient-btn">{loading ?
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                    Please Wait
                                                                </> : "Create"}</Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default CreateNewAgent
